import React from 'react';
import { Component } from 'reflux'
import Settings from './settings';
import SettingsStore from './settings_store';
import SettingsActions from './settings_actions';
import WeatherStore from './weather_store';
import WeatherActions from './weather_actions';
import images from './images';

class Weather extends Component {

  constructor(props) {
    super(props);
    const { message, weather } = WeatherStore.getInitialState();
    const settings = SettingsStore.getInitialState();
    this.state = {
      message,
      weather,
      settings
    };
    this.stores = [ SettingsStore, WeatherStore];
  }

  componentDidMount() {
    WeatherActions.getLocation();
  }

  renderWeatherDetails() {
    if (this.state.settings.get('showWeatherDetails')) {
      const units = this.state.settings.get('units');
      return (
        <ul className="weather-details">
          <li><img src={images.windPNG} alt="windy" />
            <span className="text">Wind</span>
            <span className="data">{ this.state.weather.get('wind') } { units === 'c' ? 'mps' : 'mph' }</span>
          </li>
          <li><img src={images.humidityPNG} alt="humidity" />
            <span className="text">Humidity</span>
            <span className="data">{ this.state.weather.get('humidity') }%</span>
          </li>
          <li><img src={images.pressurePNG} alt="pressure" />
            <span className="text">Pressure</span>
            <span className="data">{ this.state.weather.get('pressure') } hPa</span>
          </li>
          <li><img src={images.cloudinessPNG} alt="cloudiness" />
            <span className="text">Cloudiness</span>
            <span className="data">{ this.state.weather.get('cloudiness') }%</span>
          </li>
        </ul>
      );
    }
  }

  render() {
    const units = this.state.settings.get('units');
    const showWeatherDetails = this.state.settings.get('showWeatherDetails');
    const integration = this.state.settings.get('integration');
    const messages = this.state.message.split('\n');
    return (
      <div>
        <Settings { ...this.state.settings.toJSON() }/>
        <div className="weather">
          <div>
            <div className="city">{ this.state.weather.get('city') }</div>
            <div className="date">{ this.state.weather.get('date') }</div>
            <div className="information-message">
              *This is a DEMO APP to test and demonstrate the Pollfish survey experience for Pollfish business partners.  It is not intended for consumer use and there are no actual rewarded surveys or consumer activities available in the app.  If you are a consumer, please do not use this app.
            </div>
          </div>
          <div className="flex-container">
            <div className="flex-item-50">
              <div className="weather-info">
                <div className="flex-container">
                  <div className="temperatures">
                    <div className="conditions">{ this.state.weather.get('conditions') }</div>
                    <div className="current-temp">
                      { this.state.weather.get('temp') }
                      { this.state.weather.get('temp') !== '-//-' ?
                        <span className="degrees">°</span>
                        : ''
                      }
                    </div>
                  </div>
                  { !this.state.settings.get('userNotEligible') &&
                    <div className="flex-item-60 weather-info">
                      { showWeatherDetails && integration === 'rewarded' && this.renderWeatherDetails()}
                      { integration === 'rewarded' && showWeatherDetails === false &&
                        <button className="btn white" onClick={this.handleUnlockFeature}>Unlock New Feature</button>
                      }
                      { integration === 'offerwall' && showWeatherDetails === false &&
                        <button className="btn white" onClick={this.handleShowOfferwall}>Offerwall</button>
                      }
                    </div>
                  }
                </div>
                <div className="temp-scale">
                  { this.state.weather.get('temp_min') !== '-//-' ?
                    <div className="low-temp">{ this.state.weather.get('temp_min') }°<span style={{ textTransform: 'uppercase' }}>{units}</span></div>
                    : ''
                  }
                  <div className="gradient">
                    <img src={images.gradientSVG} alt="gradient" />
                  </div>
                  { this.state.weather.get('temp_max') !== '-//-' ?
                    <div className="high-temp">{ this.state.weather.get('temp_max') }°<span style={{ textTransform: 'uppercase' }}>{units}</span></div>
                    : ''
                  }
                </div>
              </div>
            </div>
            <div className="flex-item-50">
              <div className="gif-container">
                <img className="gif" src={images[this.state.weather.get('image')]} alt="weather" />
                { messages.map((text, index) => { return (<p key={index}>{ text }</p>) }) }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleUnlockFeature() {
    SettingsActions.set('unlock_feature', true);
  }

  handleShowOfferwall() {
    /* eslint no-undef:0 */
    Pollfish.showFullSurvey();
  }

}

export default Weather;



// WEBPACK FOOTER //
// ./src/components/weather/index.js